import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { useAuthStore, useCampStore } from '../../../stores';
import apiClient from '../../../api/apiClient';
import { BellIcon } from '../model/icons';

const LOGOUT_URL = '/api/users/protected/auth/logout';

// .topbar-right — уведомления (колокол) + аватар с меню (Выйти).
export default function TopbarActions() {
    const navigate = useNavigate();
    const token = useAuthStore(state => state.token);
    const clearToken = useAuthStore(state => state.clearToken);
    const clearCamp = useCampStore(state => state.clearCamp);

    const [profileAnchor, setProfileAnchor] = useState(null);

    const handleLogout = async () => {
        try {
            await apiClient.post(LOGOUT_URL, { accessToken: token });
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            clearToken();
            clearCamp();
            sessionStorage.removeItem('userId');
            sessionStorage.removeItem('refreshToken');
            navigate('/login');
        }
    };

    return (
        <div className="topbar-right">
            <button type="button" className="bell has-dot" aria-label="Уведомления">
                <BellIcon />
            </button>
            <button type="button" className="ava" onClick={(e) => setProfileAnchor(e.currentTarget)}>
                A
            </button>
            <Menu
                anchorEl={profileAnchor}
                open={Boolean(profileAnchor)}
                onClose={() => setProfileAnchor(null)}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                <MenuItem onClick={handleLogout}>
                    <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>Выйти</ListItemText>
                </MenuItem>
            </Menu>
        </div>
    );
}
